export const jobsImport = [
  {
    "Works End": "2023-01-28T12:00:00.000",
    "Customer Email": "susie.peterson@example.com",
    "Customer Phone": "016973 88386",
    Notes:
      "Bring the large van as recycling has been requested. \nAlso, they have a large dog.",
    "Customer Name": "Susie Peterson",
    Address: "5452 The Crescent\nBrighton and Hove\nAI7G 7BN",
    "Works Start": "2023-01-26T12:00:00.000",
    "Quote Price": 4200,
    "Quote Date": "2022-11-11T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T18:00:29.510Z",
    "Updated At": "2022-11-10T20:37:45.120Z",
    type: "row",
  },
  {
    "Updated Price": 307,
    "Works End": "2022-11-19T12:00:00.000",
    "Customer Email": "micheal.murphy@example.co",
    "Customer Phone": "07344 867816",
    Notes:
      "Adding new utils and tearing down the dividing walls. Bring large blue van.\n\nThe customer can be difficult. Avoid",
    "Customer Name": "Micheal Murphy",
    Address: "5266 York Road\nOxford\nG2 8EP",
    "Works Start": "2022-11-10T12:00:00.000",
    "Quote Price": 1231,
    "Quote Date": "2022-10-04T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T20:53:39.882Z",
    "Updated At": "2022-11-10T20:59:49.435Z",
    type: "row",
  },
  {
    "Customer Email": "",
    "Customer Phone": "07374 594595",
    Notes:
      "Removal and recycle requested of all units.\n\nStill awaiting feedback. If this is still around after next wednesday, just delete it.",
    "Customer Name": "Charlotte Carpenter",
    Address: "7780 Mill Lane\nGreater Manchester\nDU57 3GA",
    "Quote Price": 500,
    "Quote Date": "2022-11-08T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T21:03:11.782Z",
    "Updated At": "2022-11-10T21:03:11.782Z",
    type: "row",
  },
  {
    "Updated Price": 2001,
    "Works End": "2022-11-16T12:00:00.000",
    "Customer Email": "leah.freeman@example.com",
    "Customer Phone": "07844 42134",
    Notes:
      "Original quote too high. Material costs dropped.\nFull system installation.",
    "Customer Name": "Leah Freeman",
    Address: "4252 Fairview Road\nChester\nW62 7JH",
    "Works Start": "2022-11-09T12:00:00.000",
    "Quote Price": 3000,
    "Quote Date": "2022-10-04T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T20:25:44.284Z",
    "Updated At": "2022-11-10T20:54:21.655Z",
    type: "row",
  },
  {
    "Works End": "2022-11-13T12:00:00.000",
    "Customer Email": "scarlett.gibson@example.co",
    "Customer Phone": "07572 745859",
    Notes:
      "This address has a service dog.\n\nQuote didn't account for a sinkhole at the property. Amended",
    "Customer Name": "Scarlett Gibson",
    Address: "5624 The Drive\nArmagh\nNU0 5DW",
    "Works Start": "2022-11-12T12:00:00.000",
    "Quote Price": 120,
    "Quote Date": "2022-11-11T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T19:50:55.215Z",
    "Updated At": "2022-11-10T20:44:12.004Z",
    type: "row",
    "Updated Price": 175,
  },
  {
    "Customer Email": "lester.rose@example.com",
    "Customer Phone": "07103 009138",
    Notes: "4 Radiators Removed\nMany cats in the house",
    "Customer Name": "Lester Rose",
    Address: "8543 Albert Road\nNewport\nLancashire\nUnited Kingdom\nS58 5YW",
    "Quote Price": 3543,
    "Quote Date": "2022-11-10T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T18:43:21.110Z",
    "Updated At": "2022-11-10T20:40:48.241Z",
    type: "row",
  },
  {
    "Works End": "2022-11-24T12:00:00.000",
    "Customer Email": "joel.owens@example.com",
    "Customer Phone": "07216 548317",
    Notes:
      "Full retrofit of current installation. Will need big blue van. \n\nThere's a decent coffee place nearby. Ensure you buy enough for everyone.",
    "Customer Name": "Joel Owens",
    Address: "5516 Oaks Cross\nNewry\nT6V 9SL",
    "Works Start": "2022-11-24T12:00:00.000",
    "Quote Price": 789,
    "Quote Date": "2022-11-10T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T21:07:28.365Z",
    "Updated At": "2022-11-10T21:08:18.661Z",
    type: "row",
  },
  {
    "Customer Email": "freddie.franklin@example.com",
    "Customer Phone": "016977 48298",
    Notes:
      "Equipment updates and some general maintenance.\n\nHouse has 3 walls.",
    "Customer Name": "Freddie Franklin",
    Address: "2035 Brick Kiln Road\nCoventry\nTS81 7AW",
    "Quote Price": 302,
    "Quote Date": "2022-11-10T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T18:33:57.850Z",
    "Updated At": "2022-11-10T20:57:54.015Z",
    type: "row",
  },
  {
    "Works End": "2022-11-12T12:00:00.000",
    "Customer Email": "diane.henry@example.com",
    "Customer Phone": "07635 514491",
    Notes: "Large van required, recycling requested. \nNew customer",
    "Customer Name": "Diane Henry",
    Address:
      "3518 Station Road\nSunderland\nCounty Down\nUnited Kingdom\nXC67 8ES",
    "Works Start": "2022-11-11T12:00:00.000",
    "Quote Price": 2039,
    "Quote Date": "2022-11-10T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T19:23:08.036Z",
    "Updated At": "2022-11-10T20:45:40.523Z",
    type: "row",
  },
  {
    "Works End": "2022-09-23T12:00:00.000",
    "Customer Email": "warren.alvarez@example.com",
    "Customer Phone": "07768 90794",
    Notes:
      "System restoration and upgrades. \nCustomer is a smoker, bring cleaning equipment",
    "Customer Name": "Warren Alvarez",
    Address: "867 High Street\nBath\nKF8 6ZS",
    "Works Start": "2022-09-23T12:00:00.000",
    "Quote Price": 1412,
    "Quote Date": "2022-09-20T12:00:00.000",
    tableId: "ta_bb_jobs",
    "Created At": "2022-11-10T20:57:00.124Z",
    "Updated At": "2022-11-10T21:08:00.446Z",
    type: "row",
  },
]
